var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.0843.9434a12.7608 12.7608 0 0 0 .8732 24.3802 13.63 13.63 0 0 0 6.5256.0706 11.52 11.52 0 0 0 5.2228-2.7143 11.58 11.58 0 0 0 3.2265-5.2955c.624-2.2028.735-4.5192.3247-6.7716H13.2546v4.9789h6.951a5.993 5.993 0 0 1-2.5529 3.9363 7.29 7.29 0 0 1-2.8091 1.1091 8.32 8.32 0 0 1-3.045 0 7.49 7.49 0 0 1-2.8333-1.2361 7.926 7.926 0 0 1-2.924-3.9162 7.726 7.726 0 0 1 0-4.9668 7.915 7.915 0 0 1 1.8512-3.0066 7.496 7.496 0 0 1 7.552-1.9722 6.91 6.91 0 0 1 2.7506 1.6132 771 771 0 0 0 2.3473-2.3453c.4033-.4214.8429-.8227 1.2402-1.2542A12.35 12.35 0 0 0 17.6769 1.02 12.906 12.906 0 0 0 9.0843.9434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E33629",
    d: "M9.0847.9434a12.906 12.906 0 0 1 8.5925.0746 12.35 12.35 0 0 1 4.1037 2.545c-.4033.4315-.8288.8348-1.2401 1.2542q-1.1737 1.1716-2.3453 2.3352a6.91 6.91 0 0 0-2.7506-1.6132 7.495 7.495 0 0 0-7.554 1.964A7.915 7.915 0 0 0 6.0397 10.51L1.8594 7.2734a12.81 12.81 0 0 1 7.2253-6.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8BD00",
    d: "M.75 10.4798a12.7 12.7 0 0 1 1.1092-3.2064l4.1803 3.2447a7.726 7.726 0 0 0 0 4.9668 1212 1212 0 0 0-4.1804 3.2426 12.77 12.77 0 0 1-1.109-8.2477Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#587DBD",
    d: "M13.2548 10.6108h12.0025a14.99 14.99 0 0 1-.3246 6.7716 11.583 11.583 0 0 1-3.2265 5.2955c-1.3491-1.0526-2.7042-2.0972-4.0533-3.1498a5.993 5.993 0 0 0 2.553-3.9404h-6.9511c-.002-1.6576 0-3.3172 0-4.9769"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#319F43",
    d: "M1.8572 18.7275a1006 1006 0 0 0 4.1803-3.2426 7.925 7.925 0 0 0 2.928 3.9161 7.49 7.49 0 0 0 2.8393 1.2261 8.32 8.32 0 0 0 3.045 0 7.29 7.29 0 0 0 2.8091-1.1091c1.3491 1.0526 2.7042 2.0972 4.0533 3.1498a11.52 11.52 0 0 1-5.2229 2.7163 13.63 13.63 0 0 1-6.5256-.0705 12.71 12.71 0 0 1-4.638-2.3372 12.85 12.85 0 0 1-3.4685-4.2489"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-icon.1d2ea4a3ee8325e9229d76ed184f731e.svg";